import {
  AccountAnalyticsButton,
  AccountLanguagesButton,
  AccountUsers2FAButton,
  JourneyPageSettingsForm,
} from './forms'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { useStyles } from './styles'

export const DesktopSettings = () => {
  const classes = useStyles()

  return (
        <><div className={classes.itemUpperWrapper}></div><div className={classes.settingsWrapper}>
      <div className={classes.settingsBottomWrapper}>
        <div className={classes.settingsItemsWrapper}>
          {/* <div className={classes.settingsItemInerWrapper}> */}
          <div className={`${classes.itemBorder} ${classes.settingsItemWrapper}`}>
            <div className={classes.settingsItems} style={{ paddingRight: '15px' }}>
              <h4 className={classes.itemSubtitle} style={{ opacity: 0 }}>
                <HelperWrapper t="action-section-label" />
              </h4>
              <div className={classes.settingsItem}>
                <AccountLanguagesButton />
              </div>
              <div className={classes.settingsItem}>
                <AccountUsers2FAButton />
              </div>
              <div className={classes.settingsItem}>
                <AccountAnalyticsButton />
              </div>
            </div>
          </div>
          <div className={`${classes.itemBorder} ${classes.settingsItemWrapper}`}>
            <JourneyPageSettingsForm />
          </div>
          {/* </div> */}
        </div>
      </div>
    </div></>
  )
}
